import React from 'react';
import type ApiService from '../Services/Api/ApiService';

export type ApiContextProps = {
    api: ApiService | null,
    setApi: (api: ApiService | null) => void,
};

const ApiContext: React.Context<ApiContextProps> = React.createContext<ApiContextProps>({
    api: null,
    setApi: () => {},
});

export default ApiContext;